import AcessoViewModel from "@/shared/view-models/AcessoViewModel";
import AcessoController from "@/shared/controllers/acessos/AcessoController";

const name = 'g-claims'

export default {
name,

components: { }, 

 props: {
    ClaimArray: {
      type: Array,
      default: [], 
    }
},
watch:  {
   
},

  mounted () { 
    this.getAllAcessos();
   },

  updated () { },

  data () {
    return {
        acessoViewModel : new AcessoViewModel(),
        arrayAcessos: [],
        checkValue: [],
        arrayGrupos: [],
        justGrupos: new Set(),
     }
  },

  methods: {
        
        verificaClaimArray() {    
            let lstClaims = []

            Object.values(this.justGrupos).forEach((Element) => {
                Element[0].forEach(subElement => {
                    lstClaims.push({
                        Claim: subElement.claim,
                        flag: subElement[subElement.claim + 'Model'],
                        claimType: subElement.claimType
                    })
                })
            })

            this.$emit('verificaClaimArray', lstClaims)
        
          
        },
        getAllAcessos() {
            AcessoController.getAllAcessos().requisicao
            .then(res => {

                this.arrayAcessos = res.data.data
                this.arrayAcessos.forEach((Element) => {
                    if(this.ClaimArray.length > 0 ) {
                        let verificar = this.ClaimArray.find((ElementClaims) => ElementClaims.claim === Element.claim)
                        Element[Element.claim + "Model"] = verificar != null && verificar != undefined
                    } else {
                        Element[Element.claim + "Model"] = false
                    }
                })

                this.getGruposAcessos()
            })
        },
        getGruposAcessos() {
            AcessoController.getGruposAcessos().requisicao
            .then(res => {     
                this.arrayGrupos = res.data.data
                this.arrayGrupos.forEach((Element) => {
                               
                    const valoresUnicos = new Set([...this.arrayGrupos.map(x => x['claimType'])])
                    const retorno = {}
                    
                    for (let valor of valoresUnicos) {
                        retorno[valor] = [this.arrayGrupos.filter(x => x['claimType'] === valor), valor]
                    }
                    this.justGrupos = retorno
                    if(this.ClaimArray.length > 0 ) {
                        let verificar = this.ClaimArray.find((ElementClaims) => ElementClaims.claim === Element.claim)
                        Element[Element.claim + "Model"] = verificar != null && verificar != undefined
                    } else {
                        Element[Element.claim + "Model"] = false
                    }
                
                })
            })
        }
   },

  computed: { }, 

};